import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';
import { APP_ROUTES } from '../constants/app-routes';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    const user = this.authService.getUserData();

    // 1. Safeguard: Redirect to login if no user data exists
    if (!user) {
      return this.router.createUrlTree(['/login']);
    }

    // 2. Safely extract permissions (defaults to empty object if missing)
    const perms = user['ui_permissions'] || {};

    // 3. PRIORITY 1: Employers (Admin, Payroll Analyst Agent, etc.)
    // If they have employer menu access, allow them to proceed to the requested route
    if (perms.employers?.menu) {
      return true; 
    }

    // 4. PRIORITY 2: Employees (Payroll Analyst Admin)
    // If they lack employer access but have employee access, redirect them
    if (perms.employees?.menu) {
      return this.router.createUrlTree(['/', APP_ROUTES.employees.base, APP_ROUTES.employees.list]);
    }

    // 5. PRIORITY 3: Commissions (Agent)
    // If they lack both above, but have commissions access, redirect them
    if (perms.commissions?.menu) {
      return this.router.createUrlTree(['/', APP_ROUTES.commissions.base, APP_ROUTES.commissions.list]);
    }

    // 6. FALLBACK: If a user has no menu permissions at all, send them to profile
    return this.router.createUrlTree(['/', APP_ROUTES.auth.login]);
  }
}